import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../App";
import DepositComp from "../components/Dashboard/DepositComp";
import WithdrawComp from "../components/Dashboard/WithdrawComp";
import "../styles/Dashboard/components.scss";
import "../styles/Dashboard/dashboard.scss";
import "../styles/layout.scss";

const DashboardLayout = ({ children }) => {
  const [navOpen, setNavOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [depositComp, setDepositComp] = useState(false);
  const [withdrawComp, setWithdrawComp] = useState(false);
  const { userData, setUserData } = useContext(UserContext);

  useEffect(() => {
    const isLoggedIn = async () => {
      let token = localStorage.getItem("auth-token");
      if (token === "") {
        // alert("Login to access dashboard or Create an Account");
        window.location.href = "/login";
      }
    };

    isLoggedIn();
  }, []);

  const goHome = () => {
    window.location.href = "/";
  };

  const logOut = () => {
    setUserData({
      token: undefined,
      user: undefined,
    });
    localStorage.setItem("auth-token", "");
    window.location.href = "/login";
  };

  const refLink = `kuxtech-pro.vercel.app?${userData.user.firstName}_${
    userData.user.lastName
  }_${7369 + parseInt(Math.random() * 20)}_invite`;

  const user = userData.user;

  if (user.status === false) {
    return <div className="disabled">
      <h1 style={{color: "red"}}>
        ACCOUNT DISABLED DUE TO FAILURE TO VERIFY ACCOUNT.
        
        <br /> CONTACT SUPPORT.
      </h1>
    </div>
  }

  return (
    <div className="layout">
      <div className="nav-wrapper">
        <nav
          className="dashboard-nav px-0"
          // style={{ flexDirection: `${navOpen ? "row-reverse" : ""}` }}
        >
          <div className="menu">
            <button
              onClick={() =>
                userOpen ? setUserOpen(!userOpen) : setNavOpen(!navOpen)
              }
              className={`nav-btn ${navOpen ? "nav-open" : ""} ${
                userOpen ? "user-close" : ""
              }`}
            >
              <div className="box box-one"></div>
              <div className="box box-two"></div>
              <div className="box box-three"></div>
            </button>
          </div>

          <div
            className={`icons ${navOpen ? "" : ""}`}
            style={{ marginRight: `${navOpen ? "-150%" : ""}` }}
          >
            {/* <i className="far fa-envelope"></i> */}
            <Link to="" onClick={goHome}>
              <i className="user-pic fas fa-home"></i>
            </Link>
            <i
              className="user-pic fas fa-user"
              onClick={() => setUserOpen(!userOpen)}
            ></i>
          </div>
        </nav>
      </div>
      <div className="content">
        <aside className={` ${navOpen ? "aside-open" : ""}`}>
          <div className="inner">
            <ul className="">
              <li
                className="logo"
                style={{
                  width: navOpen ? "15rem" : "4rem",
                }}
              >
                <img
                  className={`fx-logo ${navOpen ? "hide-logo" : "show-logo"}`}
                  src="/imgs/logo.png"
                  alt=""
                />
                <img
                  className={`full-logo ${navOpen ? "show-logo" : "hide-logo"}`}
                  src="imgs/logofull.png"
                  alt=""
                />
              </li>
              <li className="menu wide-menu">
                <button
                  onClick={() => setNavOpen(!navOpen)}
                  className={`nav-btn ${navOpen ? "nav-open" : ""}`}
                >
                  <div className="box box-one"></div>
                  <div className="box box-two"></div>
                  <div className="box box-three"></div>
                </button>
              </li>
              <Link
                to="/dashboard"
                onClick={() => (navOpen ? setNavOpen(!navOpen) : "")}
              >
                <li>
                  <i className="fas fa-th-large"></i>
                  <p>Dashboard</p>
                </li>
              </Link>
              <hr />
              <Link
                to="/dashboard/deposit"
                onClick={() => (navOpen ? setNavOpen(!navOpen) : "")}
              >
                <li>
                  <i className="fas fa-dollar-sign"></i>
                  <p>Deposit</p>
                </li>
              </Link>
              <hr />

              <Link
                to="/dashboard/wallet"
                onClick={() => (navOpen ? setNavOpen(!navOpen) : "")}
              >
                <li>
                  <i className="fas fa-wallet"></i>
                  <p>Wallet </p>
                </li>
              </Link>
              <hr />

              <Link
                to="/dashboard/transactions"
                onClick={() => (navOpen ? setNavOpen(!navOpen) : "")}
              >
                <li>
                  <i className="far fa-calendar-alt"></i>
                  <p>Transactions </p>
                </li>
              </Link>
              <hr />

              <Link
                to="/dashboard/withdraw"
                onClick={() => (navOpen ? setNavOpen(!navOpen) : "")}
              >
                <li>
                  <i className="fas fa-credit-card"></i>
                  <p>Withdraw</p>
                </li>
              </Link>
              <hr />
              <Link to="" onClick={logOut}>
                <li className="logout">
                  <i className="fas fa-sign-out-alt"></i>
                  <p>Logout</p>
                </li>
              </Link>
            </ul>
          </div>
        </aside>
        <main className="main-content">{children}</main>

        <div className="components">
          <div className={`make-deposit ${depositComp ? "show-deposit" : ""}`}>
            <DepositComp
              setDepositComp={setDepositComp}
              // setScreenshot={setScreenshot}
            />
          </div>

          <div
            className={`withdraw-comp ${withdrawComp ? "show-withdraw" : ""}`}
          >
            <WithdrawComp
              setWithdrawComp={setWithdrawComp}
              withdrawComp={withdrawComp}
            />
          </div>
        </div>

        <div className={`user-profile ${userOpen ? "user-open" : ""}`}>
          <div className="inner">
            <div className="settings">
              <Link to="" onClick={goHome}>
                <i className="user-pic fas fa-home"></i>
              </Link>
            </div>
            <div className="close">
              <i
                className="far fa-times-circle"
                onClick={() => setUserOpen(!userOpen)}
              ></i>
            </div>

            <div className="top">
              <p className="profile-pic">
                {user.firstName ? user.firstName[0] : ""}{" "}
                {user.lastName ? user.lastName[0] : ""}
              </p>
              <div className="username">
                <p>
                  {user.firstName} {user.lastName}{" "}
                  {user.verification && <img src="/imgs/verified.png" alt="" />}
                </p>

                <small>{user.email}</small>
                {user.verification ? (
                  <small>
                    Verified account{" "}
                    <span>
                      <img src="/imgs/verified.png" alt="" />
                    </span>
                  </small>
                ) : (
                  <small style={{ color: "red" }}>
                    UnVerified account{" "}
                    <span>
                      <img src="/imgs/delete-button.png" alt="" />
                    </span>
                  </small>
                )}
              </div>
            </div>

            <hr />

            <div className="actions">
              <ul>
                <li
                  onClick={() => {
                    setDepositComp(!depositComp);
                    setWithdrawComp(withdrawComp ? !withdrawComp : "");
                  }}
                >
                  <i className="fas fa-dollar-sign"></i>
                  <p>Deposit</p>
                </li>
                <li
                  onClick={() => {
                    setWithdrawComp(!withdrawComp);
                    setDepositComp(depositComp ? !depositComp : "");
                  }}
                >
                  <i className="fas fa-money-check"></i>
                  <p>Withdraw</p>
                </li>
                <a
                  href="http://t.me/+bgUq1S1ZBZY1YTQ0"
                  target="_blank"
                  rel="noreferrer"
                >
                  <li>
                    <i className="fas fa-paper-plane"></i>
                    <p>Support</p>
                  </li>
                </a>
                {/* <li>
                  <i className="fas fa-cog"></i>
                  <p>Settings</p>
                </li> */}
              </ul>
            </div>

            <hr />

            <div className="recent-transactions">
              <div className="title">
                <h6>Recent Transactions</h6>
              </div>
              {/* {recent.slice(0, 2).map((recent) => {
                return (
                  <ul>
                    <li className="transaction">
                      <i className="fas fa-user-plus"></i>
                      <div className="transaction-title">
                        <p>{recent.type}</p>
                        <small>{recent.date}</small>
                      </div>
                    </li>
                    <li className="transaction-amount">
                      <p>${recent.amount}</p>
                    </li>
                  </ul>
                );
              })} */}

              <ul>
                <li className="transaction">
                  <i className="fas fa-user-plus"></i>
                  <div className="transaction-title">
                    <p>Sign Up Bonus</p>
                    <small>{userData.user.date}</small>
                  </div>
                </li>
                <li className="transaction-amount">
                  <p>$10</p>
                </li>
              </ul>
              {/* <ul>
                <li className="transaction">
                  <i className="fas fa-user-plus"></i>
                  <div className="transaction-title">
                    <p>Sign-up Bonus</p>
                    <small>17 Feb, 7:34 AM</small>
                  </div>
                </li>
                <li className="transaction-amount">
                  <p>$10.00</p>
                </li>
              </ul> */}
            </div>

            <hr />

            <div className="referal">
              <div className="title">
                <h6>Referal Link</h6>
              </div>

              <div className="link">
                <small>https://www.{refLink}</small>
              </div>

              <div className="link-actions">
                <p
                  onClick={() => {
                    navigator.clipboard
                      .writeText(refLink)
                      .then(() => {
                        alert("Referal Link Copied to clipboard ");
                      })
                      .catch(() => {
                        alert("Something went wrong");
                      });
                  }}
                >
                  <i className="fas fa-copy"></i> Copy
                </p>
                <p>
                  <i className="fas fa-share"></i> Share
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
